module.exports = __webpack_public_path__ + "static/media/legend_rainfallMonth.0b6d4857.png";